<script lang="ts">
    import { type NodeContent } from '$lib/bbcode/parser/types';
    import BBCodeTree from '$components/BBCode/BBCodeTree.svelte';
    import BBCodePhoto from '$components/BBCode/BBCodePhoto.svelte';
    import BBCodeList from '$components/BBCode/BBCodeList.svelte';
    import trim from 'lodash/trim';
    import BBCodeCallToAction from '$components/BBCode/CallToAction/BBCodeCallToAction.svelte';
    import BBCodeCallToActionText from '$components/BBCode/CallToAction/BBCodeCallToActionText.svelte';
    import BBCodeUrl from '$components/BBCode/BBCodeUrl.svelte';
    import BBCodeQuote from '$components/BBCode/BBCodeQuote.svelte';
    import BBCodeSlot from '$components/BBCode/BBCodeSlot.svelte';

    export let node: NodeContent;

    $: tag =
        typeof node === 'string' || typeof node === 'number'
            ? null
            : trim(node?.tag ?? '', '/ \n\t').toLowerCase();
</script>

{#if node != null}
    {#if typeof node === 'string' || typeof node === 'number'}
        {node}
    {:else if tag === 'h1'}
        <h1>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </h1>
    {:else if tag === 'h2'}
        <h2>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </h2>
    {:else if tag === 'h3'}
        <h3>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </h3>
    {:else if tag === 'h4'}
        <h4>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </h4>
    {:else if tag === 'h5'}
        <h5>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </h5>
    {:else if tag === 'h6'}
        <h6>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </h6>
    {:else if tag === 'list'}
        <BBCodeList {node} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeList>
    {:else if tag === '*'}
        <li>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </li>
    {:else if tag === 'p'}
        <p>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </p>
    {:else if tag === 'b'}
        <strong>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </strong>
    {:else if tag === 'i'}
        <em>
            <BBCodeTree nodes={node.content} let:slotName let:slotContent>
                <slot {slotName} {slotContent} />
            </BBCodeTree>
        </em>
    {:else if tag === 'photo'}
        <BBCodePhoto {node} />
    {:else if tag === 'br'}
        <br />
    {:else if tag === 'quote'}
        <BBCodeQuote {node} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeQuote>
    {:else if node.tag === 'calltoaction'}
        <BBCodeCallToAction {node} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeCallToAction>
    {:else if node.tag === 'calltoactiontext'}
        <BBCodeCallToActionText {node} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeCallToActionText>
    {:else if node.tag === 'url'}
        <BBCodeUrl {node} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeUrl>
    {:else if node.tag === 'slot'}
        <BBCodeSlot {node} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeSlot>
    {/if}
{/if}
